export const initial = {};

export const update = (state, payload) => ({
    ...state,
    ...payload,
});
